import React, { useState, useEffect, CSSProperties, useRef } from "react";
import { Table, OverlayTrigger, Tooltip, Dropdown } from "react-bootstrap";
import "jquery-confirm/css/jquery-confirm.css";
import "jquery-confirm";
import {
  CASE_STAGE_STATUS,
  EDITOR_REPORT_STATUS,
  QME_APPOINTMENT_STATUS,
  ROR_STATUS,
} from "../../../../common/Constant";
import {
  GetAssignedToReviewerList,
  updateRecordReviewerAssignedTo,
} from "../../../../services/RecordReviewerAPI";
import { DropdownPortal } from "../../../../common/DropdownPortal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import {
  setIsDashboard,
  setNewCaseInFoID,
} from "../../../../redux/slice/CaseHeaderSlice";

interface DataTableProps {
  headers: {
    key: string;
    label: string;
    sortable?: boolean;
    items?: any;
    style?: any;
    isNumeric?: boolean;
  }[];
  rows?: any[];
  onAction?: (action: string, row: any) => void;
  onSortAction?: (row: any, action?: string) => void;

  isLogTable?: boolean;

  selectedRow?: any;

  isCheckbox?: boolean;
  onCheckboxSelect?: (selectedRows: any[]) => void;
  selectedRowIds?: any;
  disabled?: boolean;
  onSaveSuccess?: any;
  selectAll?: boolean;
  setSelectAll?: (value: boolean) => void;
  filteredActionOptions?: any;
  onCaseClick?: any;
}

const RecordReviewerEditableTable: React.FC<DataTableProps> = ({
  headers,
  rows = [],
  onAction,
  onSortAction,

  isLogTable = false,

  isCheckbox = false,
  onCheckboxSelect,
  selectedRowIds = [],
  disabled = false,
  onSaveSuccess,
  selectAll = false,
  setSelectAll = () => { },
  filteredActionOptions,
  onCaseClick,
}) => {
  const [sortedRows, setSortedRows] = useState<any[]>(rows);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const dropdownRefMap = useRef<{ [key: string]: HTMLElement | null }>({});
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [focusedRowId, setFocusedRowId] = useState<number | null>(null);
  const [searchValues, setSearchValues] = useState<{ [id: number]: string }>(
    {}
  );
  const [selectedAssignee, setselectedAssignee] = useState<{
    [id: number]: number | null;
  }>({});

  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "ASC" | "DESC" | null;
  }>({
    key: "",
    direction: null,
  });
  const [openDropdownRowId, setOpenDropdownRowId] = useState<number | null>(
    null
  );
  const [assignRecordReviewerOptions, setassignRecordReviewerOptions] =
    useState<any[]>([]);

  useEffect(() => {
    const initialSelections: { [id: number]: number | null } = {};

    sortedRows.forEach((row) => {
      initialSelections[row.subjectQmeScheduleId] =
        row.assignedToUserId ?? row.medicalAssistantId ?? null;
    });

    setselectedAssignee(initialSelections);
  }, [sortedRows]);

  const handleDropdownToggle = async (
    rowId: number,
    row: any,
    isOpen: boolean
  ) => {
    setOpenDropdownRowId(isOpen ? rowId : null);
    const responseData = await GetAssignedToReviewerList(
      Number(loggedInUserid)
    );
    if (responseData?.isSuccess && Array.isArray(responseData.result)) {
      const formattedOptions = responseData.result.map((item: any) => ({
        value: item.userId,
        label: item.fullName,
      }));
      setassignRecordReviewerOptions(formattedOptions);
    }
  };

  useEffect(() => {
    if (rows && rows.length > 0) {
      (async () => {
        try {
          const stakeholderIds = [
            ...new Set(rows.map((r) => r.stakeholderId).filter(Boolean)),
          ];

          const allOptions: any[] = [];

          for (const id of stakeholderIds) {
            const responseData = await GetAssignedToReviewerList(
              Number(loggedInUserid)
            );
            if (responseData?.isSuccess && Array.isArray(responseData.result)) {
              const formattedOptions = responseData.result.map((item: any) => ({
                value: item.userId,
                label: item.fullName,
              }));
              allOptions.push(...formattedOptions);
            }
          }

          setassignRecordReviewerOptions(allOptions);
        } catch (err) {
          console.error("Error fetching assistants:", err);
        }
      })();
    }
  }, [rows]);

  const handleAssigneeChange = async (row: any, option: any) => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:00`;

    const payload = {
      subjectQMEScheduleIds: String(row.subjectQmeScheduleId),
      rorAssignedUserID: Number(option),
      rorcomments: "",
      rorAssignedDate: formattedDate,
    };
    try {
      const response = await updateRecordReviewerAssignedTo(payload);
      if (response.isSuccess) {
        setFocusedRowId(null);
        setTimeout(() => {
          onSaveSuccess();
        }, 800);
      }
    } catch (error) {
      console.error("Error updating assistant:", error);
    }
  };

  const handleSort = (key: string, direction: "ASC" | "DESC") => {
    if (sortConfig.key === key && sortConfig.direction === direction) {
      return;
    }
    const sorted = [...sortedRows].sort((a, b) => {
      if (direction === "ASC") {
        return a[key] > b[key] ? 1 : -1;
      }
      if (direction === "DESC") {
        return a[key] < b[key] ? 1 : -1;
      }
      return 0;
    });

    setSortedRows(sorted);
    setSortConfig({ key, direction });
    onSortAction?.({ key, direction });
  };
console.log(sortedRows,'sortedRows');
  useEffect(() => {
    if (
      isCheckbox &&
      rows?.length > 0 &&
      selectedRowIds?.length > 0 &&
      Array.isArray(selectedRowIds)
    ) {
      const cleanedIds = selectedRowIds.map((id: string) => id.trim());
      const selectedIdSet = new Set(cleanedIds);

      const selected = rows.filter((row) =>
        selectedIdSet.has(String(row.subjectQmeScheduleId))
      );

      setSortedRows(rows);
      setSelectedRows(selected);

      // ✅ only valid rows count
      const validRows = rows.filter(
        (row) => !NON_SELECTABLE_STAGES.includes(row?.caseStage)
      );

      const allSelected =
        validRows.length > 0 && selected.length === validRows.length;

      setSelectAll(allSelected);
    } else {
      setSortedRows(rows || []);
      setSelectedRows([]);
      setSelectAll(false);
    }
  }, [rows, selectedRowIds]);

  const NON_SELECTABLE_STAGES = [
    CASE_STAGE_STATUS.CLOSED,
    CASE_STAGE_STATUS.CANCELLED,
  ];

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;

    const attemptedRows = [...sortedRows];

    const selectableRows = sortedRows.filter(
      (row) => !NON_SELECTABLE_STAGES.includes(row?.caseStage)
    );

    if (selectableRows.length === 0) {
      setSelectAll(false);
      setSelectedRows([]);
      onCheckboxSelect?.(attemptedRows); // 🔑 parent shows CLOSED/CANCELLED message
      return;
    }

    const updated = newSelectAll ? selectableRows : [];

    setSelectAll(newSelectAll);
    setSelectedRows(updated);
    onCheckboxSelect?.(updated);
  };

  const handleCheckboxChange = (row: any) => {
    const isSelected = selectedRows.some(
      (r) => r.subjectQmeScheduleId === row.subjectQmeScheduleId
    );

    const updated = isSelected
      ? selectedRows.filter(
        (r) => r.subjectQmeScheduleId !== row.subjectQmeScheduleId
      )
      : [...selectedRows, row];

    setSelectedRows(updated);

    const validRowCount = sortedRows.filter(
      (r) => !NON_SELECTABLE_STAGES.includes(r?.caseStage)
    ).length;

    setSelectAll(validRowCount > 0 && updated.length === validRowCount);

    onCheckboxSelect?.(updated);
  };

  const dispatch = useDispatch();

  const [visibleHeaderIndex, setVisibleHeaderIndex] = useState<boolean>(false);
const isSelectAllDisabled =  
  sortedRows?.some(
    row => row.assignedToUserId !== loggedInUserid 
  );
  return (
    <>
      <div className="table-responsive border-0 mb-2">
        <Table style={{ tableLayout: "fixed" }} className="table  newtab">
          <thead>
            <tr>
              
              {isCheckbox && sortedRows?.length > 0 && (
                <th style={{ width: "45px", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    disabled={disabled || filteredActionOptions?.length == 0}
                  />
                </th>
              )}

              {headers.map((header) => (
                <th
                  key={header.key}
                  // className="adjust_ma records_column"
                  className={
                    header.key === "assignedToUserName" ||
                      header.key === "appointment_Date"
                      ? "records_column"
                      : "adjust_ma"
                  }
                  style={{
                    border: "none",
                    padding: "8px",
                    backgroundColor: "#e0f7fa",
                    color: "#000",
                    cursor: header.sortable ? "pointer" : "default",
                    position: "sticky",
                    top: 0,
                    zIndex: -90,

                    textAlign: ["dictationId"].includes(header.key)
                      ? "center"
                      : "left",
                    ...header.style,
                  }}
                >
                  <div
                    style={{
                      display: "flex",

                      justifyContent: ["dictationId"].includes(header.key)
                        ? "space-evenly"
                        : "space-between",

                      alignItems: "center",
                    }}
                  >
                    <span>{header.label}</span>
                    {header.sortable && (
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          marginLeft: "4px",
                          cursor: "pointer",
                          position: "absolute",
                          right: "0px",
                        }}
                      >
                        {!(
                          sortConfig.key === header.key &&
                          sortConfig.direction === "ASC"
                        ) && (
                            <span
                              className="material-icons"
                              style={{
                                fontSize: "18px",
                                lineHeight: "10px",
                              }}
                              onClick={() => handleSort(header.key, "ASC")}
                            >
                              arrow_drop_up
                            </span>
                          )}
                        {!(
                          sortConfig.key === header.key &&
                          sortConfig.direction === "DESC"
                        ) && (
                            <span
                              className="material-icons"
                              style={{
                                fontSize: "18px",
                                lineHeight: "10px",
                              }}
                              onClick={() => handleSort(header.key, "DESC")}
                            >
                              arrow_drop_down
                            </span>
                          )}
                      </span>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedRows?.length > 0 ? (
              sortedRows.map((row, index) => (
                <tr
                  key={row.id}
                  style={{
                    backgroundColor: index % 2 === 1 ? "white" : "#f2f2f2",
                  }}
                >
                  {isCheckbox && (
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={selectedRows.some(
                          (r) =>
                            r.subjectQmeScheduleId === row.subjectQmeScheduleId
                        )}
                        onChange={() => handleCheckboxChange(row)}
                        disabled={row.assignedToUserId !== loggedInUserid }
                      // disabled={
                      //   row.caseStage === CASE_STAGE_STATUS.CLOSED ||
                      //   row.caseStage === CASE_STAGE_STATUS.CANCELLED
                      // }
                      />
                    </td>
                  )}

                  {headers.map((header) => {
                    const cellContent = row[header.key];

                    if (header.key === "patientName") {
                      const cellContent = row[header.key];
                      return (
                        <td key={header.key}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 200, hide: 10 }}
                              overlay={
                                cellContent && cellContent?.length > 15 ? (
                                  <Tooltip
                                    id={`tooltip-${header.key}-${row.id}`}
                                    style={{ backgroundColor: "#b3e0ff" }}
                                  >
                                    {cellContent}
                                  </Tooltip>
                                ) : (
                                  <></>
                                )
                              }
                            >
                              <span
                                className="d-inline-block text-truncate"
                                style={{
                                  // maxWidth: "calc(100% - 8px)",
                                  cursor: "pointer",
                                  width: "95%",
                                  color: "#007bff",
                                }}
                              >
                                <a
                                  href="#"
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    onCaseClick(row);
                                  }}
                                >
                                  {cellContent}
                                </a>
                              </span>
                            </OverlayTrigger>
                          </div>
                        </td>
                      );
                    }

                    if (header.key === "rorDocumentInfo") {
                      const cellContent = row[header.key];
                      return (
                        <td key={header.key}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 200, hide: 10 }}
                              overlay={
                                cellContent && cellContent?.length > 15 ? (
                                  <Tooltip
                                    id={`tooltip-${header.key}-${row.id}`}
                                    style={{ backgroundColor: "#b3e0ff" }}
                                  >
                                    {cellContent}
                                  </Tooltip>
                                ) : (
                                  <></>
                                )
                              }
                            >
                              <span
                                className="d-inline-block text-truncate"
                                style={{
                                  // maxWidth: "calc(100% - 8px)",
                                  cursor: "pointer",
                                  width: "95%",
                                  color: "#007bff",
                                }}
                              >
                                <span
                                  onClick={(e) => {
                                    onAction?.(row, header.key);
                                  }}
                                >
                                  {cellContent}
                                </span>
                              </span>
                            </OverlayTrigger>
                          </div>
                        </td>
                      );
                    }

                    const isStatusColumn =
                      header.key === "rorStatus" ||
                      header.key === "rorStatusName";

                    const getStatusColor = (status: string) => {
                      switch (status) {
                        case ROR_STATUS.NOT_INITIATED:
                          return "#fa0808ff";
                        case ROR_STATUS.IN_REVIEW:
                          return "#0092d5";

                        case ROR_STATUS.REVIEW_COMPLETED:
                          return "#0E8536";
                        case ROR_STATUS.Review_Completed_Delayed:
                          return "#0E8536";
                        case ROR_STATUS.DRAFT_REVIEW:
                          return "#fcaa13ff";
                        default:
                          return "#000000";
                      }
                    };

                    return (
                      <td
                        key={header.key}
                        style={{
                          padding: header.isNumeric
                            ? "8px 20px 8px 8px !important"
                            : "8px",
                          textAlign: header.isNumeric ? "center" : "left",
                        }}
                      >
                        {header.key === "assignedToUserName" ? (
                          <>
                            <input
                              type="text"
                              className={
                                focusedRowId === row.subjectQmeScheduleId
                                  ? ""
                                  : "appointment_input"
                              }
                              disabled={
                                row.rorStatus === ROR_STATUS.REVIEW_COMPLETED ||
                                row.rorStatus ===
                                ROR_STATUS.Review_Completed_Delayed ||
                                row.rorStatus ===
                                ROR_STATUS.Cancelled_Appointment ||
                                row.caseStage === CASE_STAGE_STATUS.CLOSED ||
                                row.caseStage === CASE_STAGE_STATUS.CANCELLED
                              }
                              value={
                                searchValues[row.subjectQmeScheduleId] !==
                                  undefined
                                  ? searchValues[row.subjectQmeScheduleId] ||
                                  row.assignedToUserName ||
                                  "Select"
                                  : row.assignedToUserName || "Select"
                              }
                              ref={(el) => {
                                if (
                                  openDropdownRowId === row.subjectQmeScheduleId
                                ) {
                                  dropdownRefMap.current[
                                    row.subjectQmeScheduleId
                                  ] = el;
                                }
                              }}
                              style={{
                                cursor: "pointer",
                                color: "#000",
                                backgroundColor: "transparent",
                                border: "1px solid #ced4da",
                                borderRadius: "4px",
                                padding: "4px 8px",
                                width: "100%",
                                background: "#fff",
                              }}
                              // onClick={() => {
                              //   setFocusedRowId(row.subjectQmeScheduleId);
                              //   handleDropdownToggle(
                              //     row.subjectQmeScheduleId,
                              //     row,
                              //     openDropdownRowId !== row.subjectQmeScheduleId
                              //   );
                              // }}
                              // onChange={(e) => {
                              //   const typed = e.target.value;
                              //   setSearchValues((prev) => ({
                              //     ...prev,
                              //     [row.subjectQmeScheduleId]: typed,
                              //   }));
                              // }}
                            />
                            {focusedRowId === row.subjectQmeScheduleId && (
                              <span className="arrowpointer_appoitnment">
                                &nbsp;
                              </span>
                            )}
                            {/* <DropdownPortal
                              visible={
                                openDropdownRowId === row.subjectQmeScheduleId
                              }
                              targetRef={{
                                current:
                                  dropdownRefMap.current[
                                  row.subjectQmeScheduleId
                                  ] || null,
                              }}
                              onClose={() => {
                                setOpenDropdownRowId(null);
                                setSearchValues((prev) => ({
                                  ...prev,
                                  [row.subjectQmeScheduleId]: "",
                                }));
                              }}
                            >
                              {(() => {
                                const filteredOptions =
                                  assignRecordReviewerOptions.filter(
                                    (option: any) =>
                                      (
                                        searchValues[
                                        row.subjectQmeScheduleId
                                        ] || ""
                                      )
                                        .toLowerCase()
                                        .trim()
                                        .split(" ")
                                        .every((word) =>
                                          option.label
                                            .toLowerCase()
                                            .includes(word)
                                        )
                                  );

                                if (filteredOptions.length === 0) {
                                  return (
                                    <div
                                      style={{
                                        fontSize: "13px",
                                        padding: "5px",
                                      }}
                                      className="no_rec_data"
                                    >
                                      No Match Found
                                    </div>
                                  );
                                }

                                return filteredOptions.map((option: any) => (
                                  <Dropdown.Item
                                    key={option.value}
                                    as="label"
                                    active={
                                      option.value === row.subjectqmescheduleid
                                    }
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      handleAssigneeChange(row, option.value);
                                      setselectedAssignee((prev) => ({
                                        ...prev,
                                        [row.subjectqmescheduleid]:
                                          option.value,
                                      }));
                                      setOpenDropdownRowId(null);
                                      setSearchValues((prev) => ({
                                        ...prev,
                                        [row.subjectQmeScheduleId]: "",
                                      }));
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      name={`assignee_${row.subjectQmeScheduleId}`}
                                      checked={
                                        selectedAssignee[
                                        row.subjectQmeScheduleId
                                        ] === option.value
                                      }
                                      style={{ pointerEvents: "none" }}
                                    />
                                    {option.label}
                                  </Dropdown.Item>
                                ));
                              })()}
                            </DropdownPortal> */}
                          </>
                        ) : header.key === "rorStatus" ? (
                          <>
                            <span
                              style={{ color: getStatusColor(row.rorStatus) }}
                            >
                              {row.rorStatus}
                            </span>

                            {row.isRecordMapped == 0 &&
                              (row.rorStatus === ROR_STATUS.REVIEW_COMPLETED ||
                                row.rorStatus ===
                                ROR_STATUS.Review_Completed_Delayed) && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`icon-tooltip-${row.id}`}>
                                      ROR uploaded, no records are available in
                                      system.
                                    </Tooltip>
                                  }
                                >
                                  <span
                                    className="mx-1"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <img
                                      src="/RORCompleted.png"
                                      alt="map"
                                      className="bounce-small"
                                      style={{
                                        width: "23px",
                                        height: "21px",
                                        marginLeft: "5px",
                                      }}
                                    />
                                  </span>
                                </OverlayTrigger>
                              )}
                          </>
                        ) : header.key === "lodictationIdcations" ? (
                          <span>
                            {row.locationCity}, {row.locationZip}
                          </span>
                        ) : (
                          <OverlayTrigger
                            placement="auto"
                            delay={{ show: 200, hide: 10 }}
                            overlay={
                              cellContent &&
                                cellContent?.length > (isLogTable ? 60 : 20) ? (
                                <Tooltip
                                  id={`tooltip-${header.key}-${row.id}`}
                                  style={{ backgroundColor: "#b3e0ff" }}
                                >
                                  {cellContent}
                                </Tooltip>
                              ) : (
                                <></>
                              )
                            }
                          >
                            <span
                              className={`d-inline-flex align-items-center ${!isLogTable ? "text-truncate" : ""
                                }`}
                              style={{
                                maxWidth: isLogTable ? "none" : "90%",
                                cursor: isLogTable ? "default" : "pointer",
                                color: isStatusColumn
                                  ? getStatusColor(cellContent)
                                  : undefined,
                              }}
                            >
                              {/* === Show attachment icon if Completed === */}
                              {cellContent}
                            </span>
                          </OverlayTrigger>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers?.length} style={{ textAlign: "center" }}>
                  <span className="no_rec_data"> {"No Record Found"}</span>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default RecordReviewerEditableTable;
